import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import AccountsPage from './pages/AccountsPage';
import ActivityPage from './pages/ActivityPage';
import CodesPage from './pages/CodesPage';
import UsersPage from './pages/UsersPage';
import SettingsPage from './pages/SettingsPage';
import Shell from './components/Shell';
import AuthContext from './contexts/AuthContext';
import { useAxiosInterceptor } from './hooks/useAxiosInterceptor';

function RequireAuth({ children }) {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function RequireManager({ children }) {
  const { isAuthenticated, role } = useContext(AuthContext);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (role !== 'manager') return <Navigate to="/accounts" replace />;
  return children;
}

export default function App() {
  useAxiosInterceptor();
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <Routes>
      <Route path="/login"    element={isAuthenticated ? <Navigate to="/accounts" replace /> : <LoginPage />} />
      <Route path="/register" element={isAuthenticated ? <Navigate to="/accounts" replace /> : <RegisterPage />} />

      <Route element={<RequireAuth><Shell /></RequireAuth>}>
        <Route path="/accounts" element={<AccountsPage />} />
        <Route path="/activity" element={<ActivityPage />} />
        <Route path="/codes"    element={<RequireManager><CodesPage /></RequireManager>} />
        <Route path="/users"    element={<RequireManager><UsersPage /></RequireManager>} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      {/* Legacy + root redirects */}
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/"          element={<Navigate to={isAuthenticated ? '/accounts' : '/login'} replace />} />
      <Route path="*"          element={<Navigate to={isAuthenticated ? '/accounts' : '/login'} replace />} />
    </Routes>
  );
}
